export default __webpack_public_path__ + "media/images/images_v2/double-fleche-f6d5ab3c16faa980c914b3db528dd8af.png";